
import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import applyMiddleware from './applyMiddleware'
import HistoryStack from './historyStack'
import { initRoutesMeta } from './util'

initRoutesMeta(routes)

const router = new Router({
    // mode: 'history',
    routes
})

router.stack = new HistoryStack()
Vue.use(Router)
applyMiddleware(router)

export default router
